export type ExperimentName = (typeof allExperimentNames)[number]

export type GateName =
  | 'pay_pal_partner'
  | 'pay_pal_vault_toggle_ns'
  | 'auto_cashouts'
  | 'pay_by_bank_method'
  | 'two_factor_authentication'
  | 'loan_mvp'
  | 'order_statuses_new'
  | ''
export type DynamicConfigName =
  | 'user_browser'
  | 'user_country'
  | 'payment_method_orchestrator_config'
  | 'recaptcha_config'
  | 'express_checkout_config'
export type LayerName = ''

export const allExperimentNames = [
  'shop__ab_first_rate_strategy_pricing_plan_selector',
  'shop__ab_express_checkout_paypal_combined_module',
  'shop__ab_merge_b2cb2b_payer_data_form',
  'payer__ab_upsell_popular_label',
] as const
